import { TOAST } from '@commoncore/constants/ToastMessages';
import { WEBVIEW_MESSAGES } from '@commoncore/constants/WEBVIEW_MESSAGES';
import { BANNER_CONSTANTS } from '@commoncore/constants/bannerConstants';
import { MultiSelectLibrary } from '@commoncore/utils/MultiSelectUtil';
import { AppEvents } from '@commoncore/utils/app-events';
import { USER_DETAILS } from '../constants/Constants';

export class moveCopyImplementation {
  public router: any;
  public http: any;
  public route: any;
  public universalService: any;
  public multiSelect: any;
  public doubleClicked: boolean = false;
  public listService: any;
  public enableButton:boolean = false;
  public folderName: string="";
  contextMenuService: any;
  loggerService: any;
  globalService: any;
  source:any = "";
  destination:any ="";
  copyStatus:any = "";
  showCopyStatus:boolean = false;
  copyStatusInterval:any;
  progressPercentage:any;
  currentTab:any ="";
  retryCount:number=0;
  static singleInstance:moveCopyImplementation;
  localStorageService:any;


  constructor(globalService) {
    this.universalService = globalService.getUniversalServiceRef();
  }
  

  public setHandler(globalService) {
    this.router = globalService.getRouterRef();
    this.http = globalService.getHttpClientRef();
    this.universalService = globalService.getUniversalServiceRef();
    this.contextMenuService = globalService.getContextMenuServiceRef();
    this.route = globalService.getActivatedRoute();
    this.multiSelect = MultiSelectLibrary.getInstance(globalService);
    this.listService = globalService.getListServiceRef();
    this.loggerService = globalService.getLoggerServiceRef();
    this.localStorageService = globalService.getLocalStorageSvcRef();
  }

  public static getInstance(globalService):moveCopyImplementation{
		if(this.singleInstance == null){
			this.singleInstance = new moveCopyImplementation(globalService);
			return this.singleInstance;
		}else{
			return this.singleInstance;
		}
  }

  setPayloadForCopyOperation(source,destination,objects){
    var array = [];
    var payload = {};
    if((source == "repo" && destination == "share") || (source == "share" && destination == "repo") ){
      objects.map(obj=>{
        var objectKey;
        objectKey = obj["FullObject"]?obj["FullObject"]["objectKey"]:obj["objectKey"];
        if(!objectKey){
          objectKey = obj
        }
        array.push({
          "objectKey":objectKey
        })
      })
      payload["objects"] = array
      return  payload
    }
  }


  copyFromRepoToRepo(url,destinationObjectKey,objects){
      var params = {
          destinationObjectKey:destinationObjectKey,
          objectKeys:objects
      }
      var self = this;
      return new Promise(function(resolve,reject){
        self.http.put(url,params).subscribe(
            suc=>{
                self.loggerService.log("copied successfully",suc);
                var userData = self.localStorageService.getUserData(true);
                if(userData && userData["quota"]){
                  suc["usedSpace"] =  suc["usedSpace"] == 0 ? 0 : ( suc["usedSpace"] ?  suc["usedSpace"] : userData["quota"]["totalUsedQuota"]);
                  userData["quota"]["totalUsedQuota"] =  suc["usedSpace"];
                  AppEvents.updateAuthData.next({updateAuthData:true,userData:userData,updateStorageRepresentationOnUI:true});
                }
                resolve(suc)
            },
            err=>{
                self.loggerService.log("error in copying files",err);
                reject(err);
            }
        )
      })
  }

  
  copyFromRepoToShare(url,objects){
    var params = this.setPayloadForCopyOperation(this.source,this.destination,objects)
    var self = this;
    return new Promise(function(resolve,reject){
      self.http.put(url,params).subscribe(
          suc=>{
              self.loggerService.log("copied from repo to share successfully",suc);
              self.copyStarted();
              resolve({"resp":suc,"status":"request sent"})
          },
          err=>{
              self.loggerService.log("error in copying files from repo to share",err);
              self.universalService.showErrorMessage(err);
              self.universalService.isServerError = false;
              reject(err);
          }
      )
    })
  }

  copyFromShareToRepo(url,objects){
    var params = this.setPayloadForCopyOperation(this.source,this.destination,objects)
    var self = this;
    return new Promise(function(resolve,reject){
      self.http.put(url,params).subscribe(
          suc=>{
              self.loggerService.log("copied from repo to share successfully",suc);
              self.copyStarted();
              resolve({"resp":suc,"status":"request sent"})
          },
          err=>{
              self.loggerService.log("error in copying files from repo to share",err);
              self.universalService.showErrorMessage(err);
              this.universalService.isServerError = false;
              reject(err);
          }
      )
    })
  }

  setPayloadForTFCopyOperation(source, destination, objects) {
    var array = [];
    var payload = {};
    if((source == "repo" && destination == "teamfolder")) { //Repo to team folder 
      payload["destObjectKey"] = this.universalService.selectedFolder["objectKey"];
      payload["destTfKey"] = this.universalService.selectedFolder["tfKey"];
      objects.map(obj=>{
        var objectKey;
        objectKey = obj["FullObject"]?obj["FullObject"]["objectKey"]:obj["objectKey"];
        if(!objectKey){
          objectKey = obj
        }
        array.push({
          "objectKey":objectKey
        })
      });
      payload["objects"] = array;
    } else if((source == "teamfolder" && destination == "repo")) { //Team folder to repo
      if(this.universalService.selectedFolder == undefined){
        payload["destObjectKey"] = USER_DETAILS["USER_DETAILS"]["rootFolderKey"];
      } else {
        payload["destObjectKey"] = this.universalService.selectedFolder["objectKey"];  
      }
      objects.map(obj=>{
        var objectKey;
        var tfKey;
        objectKey = obj["FullObject"]?obj["FullObject"]["objectKey"]:obj["objectKey"];
        tfKey = obj["FullObject"]?obj["FullObject"]["tfKey"]:obj["tfKey"];
        if(this.router.url.includes('/search/tf')){
          tfKey = this.universalService.currentTeamFolder["tfKey"]
        }
        if(!objectKey){
          objectKey = obj
        }
        array.push({
          "objectKey":objectKey,
          "tfKey":tfKey
        })
      });
      payload["objects"] = array
    } else if((source == "teamfolder" && destination == "teamfolder")) { //Team folder to team folder 
      payload["destObjectKey"] = this.universalService.selectedFolder["objectKey"];
      payload["destTfKey"] = this.universalService.selectedFolder["tfKey"];
      objects.map(obj=>{
        var objectKey;
        var tfKey;
        objectKey = obj["FullObject"]?obj["FullObject"]["objectKey"]:obj["objectKey"];
        tfKey = obj["FullObject"]?obj["FullObject"]["tfKey"]:obj["tfKey"];
        if(this.router.url.includes('/search/tf')){
          tfKey = this.universalService.currentTeamFolder["tfKey"]
        }
        if(!objectKey){
          objectKey = obj
        }
        array.push({
          "objectKey":objectKey,
          "tfKey":tfKey
        })
      });
      payload["objects"] = array
    }
    return payload;
  }

  //Method to copy TF related items
  copyObjectsOfTF(url,objects){
    var params = this.setPayloadForTFCopyOperation(this.source,this.destination,objects)
    var self = this;
    return new Promise(function(resolve,reject){
      self.http.put(url,params).subscribe(
        suc=>{
            self.loggerService.log("copied from "+ self.source + " to " + self.destination + " successfully!",suc);
            resolve(suc)
        },
        err=>{
            self.listService.deSelectAll(null);
            self.loggerService.log("error in copying files from repo to tf",err);
            self.universalService.showErrorMessage(err);
            this.universalService.isServerError = false;
            reject(err);
        }
      )
    })
  }

  copyStarted(){
    this.universalService.showLoader = false;
    this.listService.deSelectAll(null);
    this.universalService.disableModalBackdrop();
    this.showCopyStatus = true;
    this.progressPercentage = 0;
    this.retryCount = 0;
    this.copyStatus = "Starting copy in a while"
  }

  getCopyStatus(statusUrl){
    var self = this;
    return new Promise(function(resolve,reject){
      self.http.get(statusUrl).subscribe(
          suc=>{
              self.loggerService.log("status of copying",suc);
              self.calculatePercentageAndShowProgressBar(suc)
          },
          err=>{
              self.loggerService.log("error in copying files from repo to share",err);
              reject(err);
          }
      )
    })
  }

  calculatePercentageAndShowProgressBar(status){
    this.progressPercentage = (parseInt(status["processObjectCount"])/parseInt(status["totalObjects"])) * 100;
    if(status["status"] == "I"){  // initialised
      this.copyStatus = TOAST["COPYING_INITIALIZED"]
      // this.checkIfTheProcessIsStuck(status);
    }else if (status["status"] == "U"){  //under process
      this.copyStatus = TOAST["COPYING_IN_PROGRESS"]
      // this.checkIfTheProcessIsStuck(status);
    }else if (status["status"] == "C"){  //completed
      this.checkIfAllTheObjectsAreCopied(status);
      clearInterval(this.copyStatusInterval);
      setTimeout(() => {
        this.showCopyStatus = false;
      }, 600);
    }else if (status["status"] == "P"){  //partial
      this.checkIfAllTheObjectsAreCopied(status);
      clearInterval(this.copyStatusInterval);
      setTimeout(() => {
        this.showCopyStatus = false;
      }, 600);
    }else if (status["status"] == "F"){ //failed
      this.checkIfAllTheObjectsAreCopied(status);
      clearInterval(this.copyStatusInterval);
      setTimeout(() => {
        this.showCopyStatus = false;
      }, 600);
    }else if (status["status"] == "E"){ // error
      this.copyStatus = TOAST["COPYING_FILES_ERROR"];
      this.progressPercentage = 100;
      clearInterval(this.copyStatusInterval);
      this.showCopyStatus = false;
      this.universalService.showToast(this.copyStatus, "error");
      if(this.universalService.currentTab == "copy" && this.universalService.inAppWebViewOpened){
        this.listService.informAndroidAndIOSToCloseWebView(WEBVIEW_MESSAGES.NONE_COPIED);
      }
      return 
    }
  }

  checkIfAllTheObjectsAreCopied(status){
    var msg = "";
    if(status["status"] == "C" /*status["processObjectCount"] == status["totalObjects"]*/){
      this.copyStatus = "Copy Completed";
      setTimeout(() => {
        msg = TOAST["COPY_SUCCESS"];
        this.universalService.showToast(msg, "success");
      }, 700);
      if(this.universalService.currentTab == "copy" && this.universalService.inAppWebViewOpened){
        this.listService.informAndroidAndIOSToCloseWebView(WEBVIEW_MESSAGES.ALL_ITEMS_COPIED_SUCESS);
      }
    }else if (status["status"] == "P" /*status["unProcessObjectCount"] != 0 && status["unProcessObjectCount"] != status["totalObjects"]*/){
      this.copyStatus = "Copied " + status["processObjectCount"] + " out of " + status["totalObjects"] + " item(s)."
      msg = TOAST["PARTIAL_COPY"];
      this.universalService.showToast(msg, "error");
      if(this.progressPercentage == 0){
        this.progressPercentage = 25;
      }
      if(this.universalService.currentTab == "copy" && this.universalService.inAppWebViewOpened){
        this.listService.informAndroidAndIOSToCloseWebView(WEBVIEW_MESSAGES.SOME_ITEMS_COPIED_SUCESS);
      }
    }else if(status["status"] == "F" /*status["unProcessObjectCount"]  ==  status["totalObjects"]*/){
      this.copyStatus = "Could not complete the action.";
      if(this.source == 'repo' && this.destination == 'share'){
        msg = TOAST["OWNER_STORAGE_FULL"];
      }
      else { 
        msg = TOAST["COPY_FAILURE"];
        // localStorage.removeItem("showStorageBanner");
        BANNER_CONSTANTS.STORAGE_BANNER["forceShow"] = true;
        AppEvents.bannerEvent.next(BANNER_CONSTANTS.STORAGE_BANNER);
      }
      this.universalService.showToast(msg, "error");
      this.progressPercentage = 100;
      if(this.universalService.currentTab == "copy" && this.universalService.inAppWebViewOpened){
      this.listService.informAndroidAndIOSToCloseWebView(WEBVIEW_MESSAGES.NOT_ENOUGH_FREE_SPACE);
      }
    }
   
  }
}
